import { render, staticRenderFns } from "./help-knowledgebase.vue?vue&type=template&id=53580915&scoped=true&lang=pug"
import script from "./help-knowledgebase.vue?vue&type=script&lang=ts"
export * from "./help-knowledgebase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53580915",
  null
  
)

export default component.exports